import {
  createDefaultFieldFactory,
  FieldTypes,
  Form,
} from '@sitecore-jss/sitecore-jss-react-forms';
import IsRtl from 'components/Shared/isRtl';
import { NextRouter, withRouter } from 'next/router';
import { useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import { useAuth } from 'src/context/AuthProvider';

const DynamicForm = ({ fields, router }: { fields: any; router: NextRouter }) => {
  const { setMessage, setIsOpen }: any = useAuth();
  const [actualDate, setActualDate] = useState<string>("")
  let lang = router.locale;
  // const clearForm = () =>{
  //   const form:any = document.getElementById("myForm");
  //   const invalidElements = document.querySelectorAll(".invalid");

  //   if (form) {
  //     const inputs = form.querySelectorAll("input, textarea, select");  
  //     inputs.forEach((input:any) => {
  //       input.value = "";
  //     });
  //     if(invalidElements.length > 0){
  //       // Remove each invalid element
  //       invalidElements.forEach((element:HTMLElement,index:number) => {
  //         if(index != 0){
  //           if (element && element.classList.length === 1 && element.classList.contains("invalid")) {
  //             element.remove()
  //           }
  //         }
  //       });
  //     }
  //   }
  // }
  // useEffect(()=>{
  //   clearForm()
  // }, [lang])
  const defaultFieldFactory = createDefaultFieldFactory();
  
  defaultFieldFactory.setComponent(FieldTypes.Telephone, (props: any): any => {
    let tempProps = { ...props, contactus: false };

    const handlePhoneChange = (value: any) => {
      const newValue = value;
      let valid = true;
      let errorMessages:any = [];
      if (props?.field.model.required && !newValue  ) {
        valid = false;
        errorMessages.push("")
      }

      props.onChange(props?.field.valueField.name, value, valid, errorMessages)
    };
  
    const handlePhoneBlur = (e:any) => {
      props?.tracker.onBlurField(props?.field, e?.target?.value, props?.errors);
    };

    const onFocus = (e: any) => {
      props?.tracker.onFocusField(props?.field, e.target.value);
    }
    return (
      <>
        <label className={`${tempProps?.field?.model?.labelCssClass}`}>
          {tempProps?.field?.model?.title}
        </label>
        <PhoneInput
          international={false}
          defaultCountry="SA"
          className={`py-0 px-6 w-full input-theme-color1 text-start ${tempProps?.field?.model?.cssClass}`}
          name={tempProps?.field?.model?.name}
          value={props.value}
          onChange={handlePhoneChange}
          onBlur={handlePhoneBlur}
          onFocus={onFocus}
          placeholder={tempProps?.field?.model?.placeholderText}
        />
        {props?.errors && (
          <div className="invalid">
            <p>{props?.errors}</p>
          </div>
        )}
      </>
    );
  });
  defaultFieldFactory.setComponent(FieldTypes.DateField, (props: any): any => {
    let tempProps = { ...props, contactus: false };

    const handleDateChange = (value: any) => {
      let newValue = value?.target?.value;
      let valid = true;
      let errorMessages:any = [];
      if(lang == "ar"){
        const formatter = new Intl.DateTimeFormat('en-GB-u-ca-islamic', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            calendar: 'islamic',
            numberingSystem: 'latn', // Use Latin numerals (0-9)
          }
        );
        const hijriDate = formatter.format(new Date(value?.target?.value));
        newValue = hijriDate.split(" ")[0]
      }
      setActualDate(newValue)
      
      if (props?.field.model.required && !newValue  ) {
        valid = false;
        errorMessages.push("")
      }

      props.onChange(props?.field.valueField.name, newValue, valid, errorMessages)
    };
  
    const handleDateBlur = (e:any) => {
      props?.tracker.onBlurField(props?.field, e?.target?.value, props?.errors);
    };
    return (
      <>
        <label className={`${tempProps?.field?.model?.labelCssClass}`}>
          {tempProps?.field?.model?.title}
        </label>
        <div className='relative'>
          <input type="date"
            value={props?.value}
            onChange={handleDateChange}
            onBlur={handleDateBlur}
          />  
          {IsRtl() && <div className='absolute top-[1.7rem] right-[2.9rem] w-1/2 bg-[#f2f2f2] z-30'>
            {actualDate}
          </div>}
        </div>
        {props?.errors && (
          <div className="invalid">
            <p>{props?.errors}</p>
          </div>
        )}
      </>
    );
  });
  
  return (
    <div id='myForm' className={`py-40 dynamic-form [&>.form-errors]:hidden ${(lang === 'ar')? 'rtl': 'ltr'}`}>
      <Form
        // language={router.locale}
        form={fields}
        sitecoreApiHost={''}
        sitecoreApiKey={process.env.NEXT_PUBLIC_SC_KEY || ""}
        fieldFactory={defaultFieldFactory}
        onRedirect={(_) => {
          setIsOpen(true);
          // clearForm()
          setMessage({ code: 200, message:lang=='ar' ? "تم الإرسال": 'Form submitted successfully'}); 
         }}
      />
    
    </div>
  );
};

export default withRouter(DynamicForm);
